import { useEffect, type Dispatch, type SetStateAction } from 'react';

/**
 * Hook to calculate and maintain table height based on viewport
 * Shared logic for both 1-line and 3-line table layouts
 */
export const useTableHeight = (setTableHeight: Dispatch<SetStateAction<number>>) => {
  useEffect(() => {
    const calculateHeight = () => {
      const viewportHeight = window.innerHeight;
      const planHeader = document.querySelector('[data-plan-header]');
      const inputSection = document.querySelector('[data-input-section]');
      const footerButtons = document.querySelector('[data-footer-buttons]');

      const topNavHeight = 64;
      const planHeaderHeight = planHeader?.getBoundingClientRect().height || 120;
      const inputSectionHeight = inputSection?.getBoundingClientRect().height || 100;
      const footerHeight = footerButtons?.getBoundingClientRect().height || 100;
      const pagePadding = 32;
      const gaps = 24;

      const otherElementsHeight =
        topNavHeight + planHeaderHeight + inputSectionHeight + footerHeight + pagePadding + gaps;

      const availableHeight = viewportHeight - otherElementsHeight;
      const minHeight = 400;
      const calculatedHeight = Math.max(minHeight, availableHeight);

      // Subtract extra space for horizontal scrollbar visibility
      setTableHeight(calculatedHeight - 30);
    };

    const timeoutId = setTimeout(calculateHeight, 100);
    window.addEventListener('resize', calculateHeight);

    return () => {
      clearTimeout(timeoutId);
      window.removeEventListener('resize', calculateHeight);
    };
  }, [setTableHeight]);
};
